import DesignSimpleForm from './DesignSimpleForm'

export default DesignSimpleForm
